import { render, staticRenderFns } from "./EditPaddingMenu.vue?vue&type=template&id=36dc1ae6&"
import script from "./EditPaddingMenu.vue?vue&type=script&lang=js&"
export * from "./EditPaddingMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports